import React, { useState } from 'react';
import { Card, Input, Button, message, Space } from 'antd';
import { LinkOutlined, EditOutlined, CheckOutlined, CloseOutlined, CopyOutlined, EyeOutlined } from '@ant-design/icons';
import api from '../../services/api';

const BRAND = '#25D366';
const BRAND_DARK = '#128C7E';

// Slug do time: mostra a URL publica compartilhavel + permite editar e copiar.
// Usado no card do perfil do time (admin.futezap e comunidade).
// Props:
//   currentSlug: slug atual (null/undefined = sem slug ainda)
//   updateEndpoint: URL do PUT (ex: '/community/teams/profile' ou '/community/team-owner/:id')
//   onSaved: callback opcional apos salvar
export default function TeamSlugCard({ currentSlug, updateEndpoint, onSaved }) {
  const [slug, setSlug] = useState(currentSlug || '');
  const [editing, setEditing] = useState(!currentSlug);
  const [saving, setSaving] = useState(false);

  const publicUrl = slug ? `https://comunidade.futezap.com.br/time/${slug}` : null;

  const save = async () => {
    const clean = String(slug || '').trim().toLowerCase();
    if (!clean) { message.warning('Digita um slug'); return; }
    setSaving(true);
    try {
      await api.put(updateEndpoint, { slug: clean });
      message.success('Link atualizado');
      setEditing(false);
      onSaved?.(clean);
    } catch (err) {
      // 429 = cooldown de 30 dias entre trocas — msg do backend ja vem
      // amigavel com a data da proxima troca.
      const msg = err?.response?.data?.message || 'Erro ao salvar';
      if (err?.response?.status === 429) message.warning(msg, 6);
      else message.error(msg);
    } finally { setSaving(false); }
  };

  const copy = () => {
    if (!publicUrl) return;
    navigator.clipboard.writeText(publicUrl);
    message.success('Link copiado!');
  };

  return (
    <Card size="small" style={{ borderRadius: 12, marginBottom: 12, borderLeft: `3px solid ${BRAND}` }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: BRAND_DARK, marginBottom: 8, letterSpacing: 0.5 }}>
        <LinkOutlined /> LINK PÚBLICO DO TIME
      </div>
      {!editing && publicUrl ? (
        <>
          <div style={{
            padding: '8px 12px', background: '#f0fdf4', borderRadius: 8,
            fontFamily: 'monospace', fontSize: 13, color: BRAND_DARK, wordBreak: 'break-all',
            marginBottom: 8,
          }}>
            {publicUrl}
          </div>
          <Space wrap>
            <Button size="small" icon={<EyeOutlined />}
              onClick={() => window.open(publicUrl, '_blank', 'noopener')}>
              Ver página
            </Button>
            <Button size="small" icon={<CopyOutlined />} onClick={copy}>Copiar</Button>
            <Button size="small" icon={<EditOutlined />} type="text"
              onClick={() => setEditing(true)}>Trocar</Button>
          </Space>
        </>
      ) : (
        <>
          <Input
            addonBefore="/time/"
            value={slug}
            onChange={e => setSlug(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
            placeholder="meu-time-legal"
            maxLength={20}
            style={{ marginBottom: 8 }}
          />
          <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8 }}>
            Só letras minúsculas, números e hífen. Ex: resenhafc, racha-quarta.
            {currentSlug && <> Depois de trocar, só dá pra mudar de novo em 30 dias.</>}
          </div>
          <Space>
            <Button size="small" type="primary" icon={<CheckOutlined />} loading={saving}
              onClick={save} style={{ background: BRAND, borderColor: BRAND }}>
              Salvar
            </Button>
            {currentSlug && (
              <Button size="small" icon={<CloseOutlined />}
                onClick={() => { setSlug(currentSlug); setEditing(false); }}>
                Cancelar
              </Button>
            )}
          </Space>
        </>
      )}
    </Card>
  );
}
